<div class="company-has-certificate-card overflow-visible">
	<form [formGroup]="form">
		<div class="form-row" [ngClass]="{'margin-bottom15': order.company.isMultiSite === true}">
			<div class="radio-button-group margin-bottom15">
				<nb-radio-group id="multiSite" name="multiSite" [status]="isInvalid('multisite') ? 'danger' : 'primary'"
								formControlName="multisite" (valueChange)="updateFormControl('multisite', $event)"
								[disabled]="multisiteDisabled$ | async">
					<nb-radio name="multiSiteRadio" [value]="true">{{ 'common.yes' | translate }}</nb-radio>
					<nb-radio name="multiSiteRadio" [value]="false">{{ 'common.no' | translate }}</nb-radio>
				</nb-radio-group>
			</div>
			<div class="padding-top5 question-div">
				<span id="multiSite-question" class="certification-question">{{ 'company-has-certificate.multi-site-question' | translate }}</span>
				@if (isInvalid('multisite')) {
					<div class="validation-message">{{ getValidationErrors('multisite') | async }}</div>
				}
			</div>
		</div>
		@if (order.company.isMultiSite === true) {
			<div>
				<div class="margin-bottom15" style="align-items: end">
					<div *ngIf="showExtendedInfo else basicInfo" class="margin-bottom15" style="max-width: 429px;">
            <span class="redirection-message-multisite">
              {{ 'company-has-certificate.redirection-message-multisite-1' | translate }}
				<a [href]="multisiteRedirectionMultisiteHereUrl() | translate">{{ 'company-has-certificate.redirection-message-multisite-here' | translate }}</a>
				{{ 'company-has-certificate.redirection-message-multisite-2' | translate }}
				<a [href]="'mailto: ' + ('common.sales-contact-email-multisite' | translate)" target="_blank">{{ 'common.sales-contact-email-multisite' | translate }}</a>.
            </span>
					</div>
					@if (multisiteButtonVisible) {
						<div>
							<a #redirectLink class="button-redirect-link" [href]="multisiteRedirectionContactFormUrl() | translate">
								<button nbButton id="redirect-button" size="large" status="primary" (click)="redirectLink.click()">{{ 'company-has-certificate.redirect-button' | translate }}
									<nb-icon class="arrow-icon" status="primary" icon="arrow-forward-outline"></nb-icon>
								</button>
							</a>
						</div>
					}
				</div>
			</div>
		}

		@for (product of order.products; track $index) {
			<div class="form-row margin-bottom15">
				<div class="radio-button-group">
					<nb-radio-group id="{{getFormControlName(product)}}" name="{{getFormControlName(product)}}"
									[status]="isInvalid(getFormControlName(product)) ? 'danger' : 'primary'"
									[formControlName]="getFormControlName(product)" [attr.formcontrolname]="getFormControlName(product)" (valueChange)="updateHasCertificate(product, $event)"
									[disabled]="shouldDisableRadio(product)">
						<nb-radio name="{{getFormControlName(product)}}Radio" [value]="true">{{ 'common.yes' | translate }}</nb-radio>
						<nb-radio name="{{getFormControlName(product)}}Radio" [value]="false">{{ 'common.no' | translate }}</nb-radio>
					</nb-radio-group>
				</div>
				<div class="padding-top5">
					<span class="certification-question">{{ 'company-has-certificate.certification-question' | translate:{standards: getStandardName(product)} }}</span>
					@if (isInvalid(getFormControlName(product))) {
						<div class="validation-message">{{ getValidationErrors(getFormControlName(product)) | async }}</div>
					}
				</div>
			</div>
		}
	</form>
</div>
